import { render, staticRenderFns } from "./menuConfiguration.vue?vue&type=template&id=33fdc84e&"
import script from "./menuConfiguration.vue?vue&type=script&lang=js&"
export * from "./menuConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports